import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

type StyledSkeletonProps = {
  $width?: string | number;
  $height?: string | number;
  $aspectRatio?: string;
  $rounded?: boolean;
};

function toCssSize(value: string | number | undefined): string | undefined {
  if (value == null) return undefined;
  return typeof value === 'number' ? `${value}px` : value;
}

export const StyledSkeleton = styled.div<StyledSkeletonProps>`
  display: block;
  box-sizing: border-box;
  width: ${({ $width }) => toCssSize($width) ?? '100%'};
  height: ${({ $height, $aspectRatio }) =>
    $aspectRatio ? undefined : (toCssSize($height) ?? '1em')};
  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio};
  border-radius: ${({ theme, $rounded }) =>
    $rounded
      ? (theme?.component?.skeleton?.roundedBorderRadius ?? '8px')
      : (theme?.component?.skeleton?.borderRadius ?? '4px')};
  background: linear-gradient(
    90deg,
    ${({ theme }) =>
        theme?.component?.skeleton?.baseColor ??
        theme?.colors?.background?.secondary ??
        '#f5f5f5'}
      0%,
    ${({ theme }) =>
        theme?.component?.skeleton?.highlightColor ??
        theme?.colors?.background?.primary ??
        '#ffffff'}
      50%,
    ${({ theme }) =>
        theme?.component?.skeleton?.baseColor ??
        theme?.colors?.background?.secondary ??
        '#f5f5f5'}
      100%
  );
  background-size: 200% 100%;
  animation: ${shimmer}
    ${({ theme }) => theme?.component?.skeleton?.duration ?? '1.5s'} infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    background: ${({ theme }) =>
      theme?.component?.skeleton?.baseColor ??
      theme?.colors?.background?.secondary ??
      '#f5f5f5'};
  }
`;
